<template>
    <div class="game-footer">      

        <InfoNotification
        v-if="actualView.acceptCheckbox"
        />

        <FooterButtons

        />

    </div>
</template>
  
<script>
import { mapGetters } from 'vuex'
import FooterButtons from "@/components/game/FooterButtons.vue"
import InfoNotification from "@/components/game/InfoNotification.vue"

export default {
    name: 'GameFooter',
    components: {
        FooterButtons,
        InfoNotification
    },
    props: {
        footerData: {}
    },
    computed: {
        ...mapGetters([
            "actualView"
        ])
    }
}
</script>
  
<style>
    
</style>